import analysisMapModule from "../analysisMapModule"
import template from "./selectMakers.html"
import _ from "lodash"

analysisMapModule.directive("selectMakersDirective", function () {
    return {
        restrict: "E",
        template: template,
        scope: {
            orderSummaries: "=",
            textTitle: "@",
        },
        controller: ["$scope", function ($scope) {

            $scope.getTotalQuantityOfOrders = function () {
                return $scope.orderSummaries.length
            }

            $scope.getTotalQuantityOfOrderItems = function () {
                return _.sum($scope.orderSummaries.map(orderSummary => orderSummary.totalQuantityOfOrderItems))
            }

            $scope.getTotalVolume = function () {
                return _.sum($scope.orderSummaries.map(orderSummary => orderSummary.totalVolume))
            }

            $scope.getTotalWeight = function () {
                return _.sum($scope.orderSummaries.map(orderSummary => orderSummary.totalWeight))
            }

            $scope.getTotalValue = function () {
                return _.sum($scope.orderSummaries.map(orderSummary => orderSummary.totalValue))
            }
        }]
    }
})